import React from 'react';
import { Chip as MuiChip, makeStyles } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import PropTypes from 'prop-types';

const propTypes = {
  checked: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};
const defaultProps = {
  disabled: false,
};

const useStyles = makeStyles(() => ({
  chip: {
    fontSize: '14px',
    height: '28px',
  },
  chipDeleteIcon: {
    color: '#2F6095',
    height: '15px',
    width: '15px',
    '&:hover': { color: '#2F6095' },
  },
  chipSelected: {
    backgroundColor: '#A2BEDC',
    color: '#042440',
    '&:hover': { backgroundColor: '#A2BEDC', color: '#042440' },
    '&:focus': { backgroundColor: '#81a6d0', color: '#042440' },
  },
}));

function Chip({ checked, disabled, label, value, onClick, onDelete }) {
  const classes = useStyles();

  return (
    <MuiChip
      classes={{ root: classes.chip, colorPrimary: classes.chipSelected }}
      disabled={disabled}
      color={checked ? 'primary' : 'default'}
      deleteIcon={checked ? <Close className={classes.chipDeleteIcon} /> : undefined}
      label={label}
      variant={checked ? 'default' : 'outlined'}
      onClick={() => onClick(value)}
      onDelete={checked ? () => onDelete(value) : undefined}
    />
  );
}

Chip.propTypes = propTypes;
Chip.defaultProps = defaultProps;

export default Chip;
